var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineeducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_17243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3688 28.8499H15.0688L14.3188 26.8249H2.99377V7.5499C2.99377 6.6499 3.74377 5.8999 4.64377 5.8999H32.6938C33.5938 5.8999 34.3438 6.6499 34.3438 7.5499V26.8999H22.8688L21.3688 28.8499ZM15.8938 27.7249H20.8438L22.3438 25.6999H33.2188V7.5499C33.2188 7.2499 32.9938 7.0249 32.6938 7.0249H4.64377C4.34377 7.0249 4.11877 7.2499 4.11877 7.5499V25.7749H15.1438L15.8938 27.7249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2688 31.1H6.06885C3.36885 31.1 1.19385 28.925 1.19385 26.225V25.625H15.0688L15.8188 27.65H20.7688L22.2688 25.625H36.0688V26.225C36.1438 28.925 33.8938 31.1 31.2688 31.1ZM2.39385 26.825C2.69385 28.625 4.19385 29.975 6.06885 29.975H31.1938C33.0688 29.975 34.6438 28.625 34.8688 26.825H22.8688L21.3688 28.85H15.0688L14.3188 26.825H2.39385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1938 9.875H7.41882V14.9H13.1938V9.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 15.4249H6.81885V9.2749H13.7188V15.4249ZM7.94385 14.2999H12.5938V10.3999H7.94385V14.2999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1938 17.825H7.41882V22.8499H13.1938V17.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 23.45H6.81885V17.3H13.7188V23.45ZM7.94385 22.325H12.5938V18.425H7.94385V22.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2188 11.75H16.7938V12.875H30.2188V11.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2188 19.7749H16.7938V20.8999H30.2188V19.7749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_17243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.668823 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineeducation);
export default __webpack_public_path__ + "static/media/onlineeducation.c64bd3dca7d9b6e82ce0ae558ccbfdf5.svg";
export { ForwardRef as ReactComponent };